import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import dateUtil from '../../util/date';
import template from './datePicker.jsx';
var NUMBER_OF_WEEKS_FOR_FIXED_HEIGHT = 6;

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);
    _this.state = {
      value: dateUtil.isValid(props.value) ? props.value : new Date()
    };

    _this.getDatesInMonth = function () {
      var days = [];
      var firstDayIndex = _this.props.startDay ? _this.props.days.indexOf(_this.props.startDay) : 0;
      var day = new Date(_this.state.value.getFullYear(), _this.state.value.getMonth(), 1);

      while (day.getDay() !== firstDayIndex) {
        day = new Date(day.getFullYear(), day.getMonth(), day.getDate() - 1);
        days.unshift(day);
      }

      day = new Date(_this.state.value.getFullYear(), _this.state.value.getMonth(), 1);

      while (day.getMonth() === _this.state.value.getMonth()) {
        days.push(day);
        day = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1);
      }

      while (day.getDay() !== firstDayIndex) {
        days.push(day);
        day = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1);
      }

      if (_this.props.fixedNumberOfRows) {
        var daysLeft = NUMBER_OF_WEEKS_FOR_FIXED_HEIGHT * 7 - days.length;

        _.times(daysLeft, function () {
          days.push(day);
          day = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1);
        });
      }

      return days;
    };

    _this.getDays = function () {
      var result = _this.props.days;
      var startDay = _this.props.startDay ? _this.props.startDay : result[0];

      while (result[0] !== startDay) {
        result.push(result.shift());
      }

      return result;
    };

    _this.getElementClasses = function (date) {
      var classes = ['dp-day', !date || date.getMonth() !== _this.state.value.getMonth() && 'dp-day-not-in-current-month', _this.isEquals(date, _this.props.value) && 'dp-day-selected', _this.isEquals(date, new Date()) && 'dp-today', _this.props.validateDate && !_this.props.validateDate(date) && 'dp-day-disabled'];
      return _(classes).compact().join(' ');
    };

    _this.getMonthTitle = function () {
      var monthName = _this.props.monthNames[_this.state.value.getMonth()];

      return monthName + ' ' + _this.state.value.getFullYear();
    };

    _this.isEquals = function (date1, date2) {
      if (date1 && !date2 || date2 && !date1) {
        return false;
      }

      return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
    };

    _this.updateMonth = function (step) {
      var newDate = new Date(_this.state.value.getFullYear(), _this.state.value.getMonth() + step, _this.state.value.getDate());

      _this.setState({
        value: newDate
      });
    };

    return _this;
  }

  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return DatePicker;
}(React.Component);

DatePicker.displayName = 'DatePicker';
DatePicker.propTypes = {
  /** Callback called on date change. Called with date as argument. */
  onChange: PropTypes.func.isRequired,

  /** Date value */
  value: PropTypes.object,

  /** Label for today button. Navigates to current date in the picker. */
  todayLabel: PropTypes.string,

  /** Label for "Go to Selected" button. Navigates to selected date in the picker. */
  goToSelectedLabel: PropTypes.string,

  /** Start of the week day. Must match `days`. */
  startDay: PropTypes.string,

  /** Array of day names / initials to display */
  days: PropTypes.arrayOf(PropTypes.string),

  /** Array of month names to display */
  monthNames: PropTypes.arrayOf(PropTypes.string),

  /** When on – displays delete button. Calls `onChange` callback with `null`. */
  showDelete: PropTypes.bool,

  /** When on – always shows six weeks in the picker. */
  fixedNumberOfRows: PropTypes.bool,

  /** A predicate function to decide what dates are accepted.*/
  validateDate: PropTypes.func
};
DatePicker.defaultProps = {
  value: new Date(),
  todayLabel: 'Today',
  goToSelectedLabel: 'Go to selected',
  startDay: 'S',
  days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  showDelete: true,
  fixedNumberOfRows: true
};
export default compose(DatePicker);